module.exports = __webpack_public_path__ + "./img/ConsultadorDetalleArticulo.680ab378af6909c18bfb8a8e6312bbc5.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/Help/ConsultadorDetalleArticulo.png
// module id = ./public/img/Help/ConsultadorDetalleArticulo.png
// module chunks = 0